import React from 'react'
import { Text } from '../../../constants/TextConstants'
import PropTypes from 'prop-types'
import { PaginationControlWrapper, PaginationButton } from './styles'
import { BqIcon } from '@beeq/react'
import LastPageControl from './LastPageControl'
import FirstPageControl from './FirstPageControl'

const PageControl = ({
  currentPage,
  totalItems,
  defaultPageSize,
  onPageChange,
  expandedPagesCount = 3,
  expandThreshold = 5
}) => {
  const pageValues = []
  const totalPages = Math.ceil(totalItems / defaultPageSize)
  const dynamicThreshold = currentPage < expandThreshold ? expandThreshold : expandedPagesCount
  const isFirstPageSelected = currentPage === 1
  const isLastPageSelected = currentPage === totalPages
  const hasPages = totalPages !== 0

  let startPage = Math.max(1, currentPage - Math.floor(dynamicThreshold / 2))
  let endPage = Math.min(totalPages, startPage + dynamicThreshold - 1)

  if (currentPage > totalPages - expandThreshold + 1) {
    startPage = totalPages - expandThreshold + 1
    endPage = totalPages
  }

  if (currentPage < expandThreshold) {
    startPage = 1
    endPage = expandThreshold
  }

  for (let i = startPage; i <= Math.min(endPage, totalPages); i++) {
    pageValues.push(i)
  }

  return (
    <PaginationControlWrapper>
      {hasPages && (
        <>
          <PaginationButton
            data-testid='prev-page-button'
            title={Text.PageControlPreviousPageTitle}
            size='small'
            appearance='text'
            disabled={isFirstPageSelected}
            onBqClick={() => onPageChange(currentPage - 1 > 0 ? currentPage - 1 : currentPage)}>
            <BqIcon name='caret-left' />
          </PaginationButton>
          <FirstPageControl startPage={startPage} onPageChange={onPageChange} />
          {pageValues.map((pageValue) => (
            <PaginationButton
              key={pageValue}
              data-testid={`page-${pageValue}-button`}
              title={`${Text.PageControlPageTitle} ${pageValue}`}
              size='small'
              appearance={pageValue === currentPage ? 'primary' : 'text'}
              onBqClick={() => onPageChange(pageValue)}>
              {pageValue}
            </PaginationButton>
          ))}
          <LastPageControl endPage={endPage} totalPages={totalPages} onPageChange={onPageChange} />
          <PaginationButton
            data-testid='next-page-button'
            title={Text.PageControlNextPageTitle}
            size='small'
            appearance='text'
            disabled={isLastPageSelected || totalPages === 0}
            onBqClick={() => onPageChange(currentPage + 1 <= totalPages ? currentPage + 1 : currentPage)}>
            <BqIcon name='caret-right' />
          </PaginationButton>
        </>
      )}
    </PaginationControlWrapper>
  )
}

export default PageControl

PageControl.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  defaultPageSize: PropTypes.number,
  expandedPagesCount: PropTypes.number,
  expandThreshold: PropTypes.number
}
